import styled from "styled-components";
import beAReseller from "assets/supergasbras/images/beAReseller.jpeg";
import fingerPrint from "assets/supergasbras/images/fingerPrint.png";
import { Link } from "react-router-dom";

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  .css-1nxtzl-MuiGrid-root > .MuiGrid-item {
    padding-top: 0;
  }
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Account = styled.div`
  width: 100%;
  flex-direction: row;
  align-items: flex-start;
`;

export const ContainerBackground = styled.div`
  display: flex;
  height: 100vh;
  width: 100%;
  background-image: url(${beAReseller});
  background-position: top right;
  background-repeat: no-repeat;
  background-size: cover;
`;

export const ContainerFingerPrint = styled.div`
  display: flex;
  margin: 0 auto;
  height: 200px;
  width: 200px;
  background-image: url(${fingerPrint});
  background-position: top right;
  background-repeat: no-repeat;
  background-size: cover;
`;

export const ForgotPasswordText = styled(Link)`
  color: ${({ theme }) => theme.palette.primary.main};
  text-decoration: underline;
`;

export const ContainerContent = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
`;
